import { WebContentButtonTranslationApiModel } from './WebContentButtonTranslationApiModel';

export enum OpenUrlWith {
	IFrame = 'IFrame',
	SameTab = 'SameTab',
	NewTab = 'NewTab',
}

export class WebContentButtonApiModel {
	Id: number;
	ReceptionId: number;
	IconUrl: string;
	HasBrandedNavbar: boolean;
	RequiresAuthentication: boolean;
	IsActive: boolean;
	OpenUrlWith: OpenUrlWith;
	Translations: WebContentButtonTranslationApiModel[];
}
